import { EmptyStateStyled } from '@procurify/ui'
import styled from 'styled-components'

import { BudgetCategoryCardStyled } from '@webapp/components/Budgets/BudgetCategoryCard/styles/BudgetCategoryCardStyled'

interface IBudgetCategoryDetailsCardStyledProps {}

export const BudgetCategoryDetailsCardStyled = styled.div<IBudgetCategoryDetailsCardStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  background: ${(props) => props.theme.colors.white};

  ${BudgetCategoryCardStyled} {
    border: none;
    border-radius: ${(props) =>
      props.theme.box.borderRadius(props.theme.typography.htmlFontSize)};

    box-shadow: ${(props) => props.theme.shadows[3]};

    ${EmptyStateStyled} {
      margin: 0;
    }
  }
`
